export const TAG_SUGGESTIONS = [
  /*Mathematics*/
  "Pre-Algebra",
  "Algebra 1",
  "Algebra 2",
  "Geometry",
  "Trigonometry",
  "Pre-Calculus",
  "Calculus",
  "Differential Equations",
  "Statistics",
  "Integrated math",
  "Abstract Algebra",
  "Probability and statistics",

  /*History*/
  "American History",
  "World History",
  "Geography",
  "US Government",
  "European history",
  "International relations",
  "Economics",
  "Psychology",
  "Women's studies",
  "Religious studies",
  "Sociology",
  "Anthropology",
  "Political science",
  "Current events",
  "World religions",
  /*Science*/
  "Earth science",
  "Physical science",
  "Biology",
  "Chemistry",
  "Organic chemistry",
  "Physics",
  "Life science",
  "Environmental science",
  "Astronomy",
  "Zoology",
  "Oceanography",
  "Forensic science",
  "Botany",
  /*Health*/
  "Health",
  "Mental Health",
  "Nursing",
  /*Foreign Languages*/
  "Spanish",
  "French",
  "German",
  "Latin",
  "American Sign Language",
  "Portuguese",
  "Arabic",
  "Chinese",
  "Japanese",
  "Korean",
  "Italian",
  "Russian",
  "Hindi",
  "Nepali", //hehe
  /*Electives*/
  /*Language & Arts*/
  "African literature",
  "Asian literature",
  "British literature",
  "Cinema studies",
  "Contemporary literature",
  "Creative writing",
  "Debate",
  "Film study",
  "Gothic literature",
  "Humanities",
  "Journalism",
  "Poetry",
  "Popular literature",
  "Practical writing",
  "Public speaking",
  "Rhetoric",
  "Works of Shakespeare",
  "World literature",
  /*Performing Arts*/
  "Choir",
  "Jazz band",
  "Concert band",
  "Marching band",
  "Orchestra",
  "Music theory",
  "Dance",
  "Drama",
  /*Visual Arts*/
  "Art history",
  "Drawing",
  "Painting",
  "Digital media",
  "Film production",
  "Photography",
  "Printmaking",
  "Sculpture",
  "Ceramics",
  /*Physical Education*/
  "Team sports",
  "Health",
  "Wellness",
  "Swimming",
  "Gymnastics",
  "Weight training",
  "Aerobics",
  "Racket sports",
  "Yoga",
  "Physical education",
  /*Business*/
  "Accounting",
  "Entrepreneurship",
  "Marketing",
  "Personal finance",
  "Business",
  /*Computer Science and Information Technology*/
  "Artificial Intelligence",
  "Computer literacy",
  "Computer programming",
  "Computer science",
  "Graphic design",
  "Film production",
  "Music production",
  "Web design",
  "Word processing",
  "Media studies",
  /*Family and Consumer Science*/
  "Culinary arts",
  "Chemistry of foods",
  "Early childhood development",
  "Fashion and retail merchandising",
  "Home economics",
  "Nutrition",
  "CPR",
  "Fashion design",
  "Retail marketing",
  /*Vocational Education*/
  "Auto repair",
  "Woodworking",
  "Computer-aided drafting",
  "Driver education",
  "Cosmetology",
  "JROTC",
  "Networking",
  "Metalworking",
  "Robotics",
  "FFA",
  "Electronics",
  /*Advanced Placement*/
  "AP Research",
  "AP Seminar",
  "AP Art & Design",
  "AP Music Theory",
  "AP English Language & Composition",
  "AP English Literature & Composition",
  "AP Comparative Government and Politics",
  "AP European History",
  "AP Human Geography",
  "AP Macroeconomics",
  "AP Microeconomics",
  "AP Psychology",
  "AP United States Government and Politics",
  "AP United States History",
  "AP World History: Modern",
  "AP Calculus AB",
  "AP Calculus BC",
  "AP Computer Science A",
  "AP Computer Science Principles",
  "AP Statistics",
  "AP Biology",
  "AP Chemistry",
  "AP Environmental Science",
  "AP Physics 1: Algebra-Based",
  "AP Physics 2: Algebra-Based",
  "AP Physics C: Electricity and Magnetism",
  "AP Physics C: Mechanics",
  "AP Chinese Language and Culture",
  "AP French Language and Culture",
  "AP German Language and Culture",
  "AP Italian Language and Culture",
  "AP Japanese Language and Culture",
  "AP Latin",
  "AP Spanish Language and Culture",
  "AP Spanish Literature and Culture",
  /*Misc*/
  "Vocabulary",
  "SAT Prep",
];

export const SUBJECTS = [
  "Math",
  "Science",
  "History",
  "Technology",
  "Languages",
];
export const SECONDARY_SUBJECTS = {
  Math: [
    "Pre Algebra",
    "Algebra 1",
    "Geometry",
    "Algebra 2",
    "Trigonometry",
    "Pre-Calculus",
    "Calculus",
    "Differential Equations",
    "Statistics",
    "Integrated math",
    "Abstract Algebra",
    "Probability and Statistics",
  ],
  History: [
    "American History",
    "World History",
    "Geography",
    "US Government",
    "European history",
    "International relations",
    "Economics",
    "Psychology",
    "Women's studies",
    "Religious studies",
    "Sociology",
    "Anthropology",
    "Political science",
    "Current events",
    "World religions",
  ],
  Science: [
    "Earth science",
    "Physical science",
    "Biology",
    "Chemistry",
    "Organic chemistry",
    "Physics",
    "Life science",
    "Environmental science",
    "Astronomy",
    "Zoology",
    "Oceanography",
    "Forensic science",
    "Botany",
  ],
  Technology: [
    "Digital media",
    "Film production",
    "Artificial Intelligence",
    "Computer literacy",
    "Computer programming",
    "Computer science",
    "Graphic design",
    "Music production",
    "Web design",
    "Word processing",
    "Media studies",
  ],
  Languages: [
    "Spanish",
    "French",
    "German",
    "Latin",
    "American Sign Language",
    "Portuguese",
    "Arabic",
    "Chinese",
    "Japanese",
    "Korean",
    "Italian",
    "Russian",
    "Hindi",
    "Nepali",
  ],
};
export const SUBJECT_ICONS = {
  Math: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.66"
      height="26.66"
      viewBox="0 0 26.66 26.66"
    >
      <path
        id="calculate_FILL0_wght400_GRAD0_opsz24"
        d="M127.406-817.783h2.222v-2.962h2.962v-2.222h-2.962v-2.962h-2.222v2.962h-2.962v2.222h2.962Zm7.406-1.111h7.406v-2.222h-7.406Zm0-3.7h7.406v-2.222h-7.406Zm1.629-5.628,2.074-2.074,2.074,2.074,1.555-1.555-2.074-2.148L142.143-834l-1.555-1.555-2.074,2.074-2.074-2.074L134.885-834l2.074,2.074-2.074,2.148Zm-11.627-2.592h7.406v-2.222h-7.406Zm-1.851,17.477a2.852,2.852,0,0,1-2.092-.87A2.852,2.852,0,0,1,120-816.3v-20.736a2.852,2.852,0,0,1,.87-2.092,2.852,2.852,0,0,1,2.092-.87H143.7a2.852,2.852,0,0,1,2.092.87,2.852,2.852,0,0,1,.87,2.092V-816.3a2.852,2.852,0,0,1-.87,2.092,2.852,2.852,0,0,1-2.092.87Zm0-2.962H143.7v-20.736H122.962Zm0-20.736v0Z"
        transform="translate(-120 840)"
        fill="#6c53a7"
      />
    </svg>
  ),
  Science: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.314"
      height="27.227"
      viewBox="0 0 27.314 27.227"
    >
      <path
        id="science_FILL0_wght400_GRAD0_opsz24"
        d="M121.928-812.773a2.811,2.811,0,0,1-2.742-1.721,2.8,2.8,0,0,1,.4-3.2l8.4-10.21v-9.076h-1.513a1.463,1.463,0,0,1-1.078-.435,1.463,1.463,0,0,1-.435-1.078,1.464,1.464,0,0,1,.435-1.078,1.463,1.463,0,0,1,1.078-.435h12.1a1.463,1.463,0,0,1,1.078.435,1.464,1.464,0,0,1,.435,1.078,1.463,1.463,0,0,1-.435,1.078,1.463,1.463,0,0,1-1.078.435h-1.513v9.076l8.4,10.21a2.8,2.8,0,0,1,.4,3.2,2.811,2.811,0,0,1-2.742,1.721Zm0-3.025H143.1l-9.076-11.042v-10.135H131v10.135ZM132.517-826.386Z"
        transform="translate(-118.86 840)"
        fill="#6c53a7"
      />
    </svg>
  ),
  History: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32.715"
      height="32.715"
      viewBox="0 0 32.715 32.715"
    >
      <path
        id="public_FILL0_wght400_GRAD0_opsz24"
        d="M96.357-847.285a15.93,15.93,0,0,1-6.379-1.288,16.517,16.517,0,0,1-5.193-3.5,16.517,16.517,0,0,1-3.5-5.193A15.928,15.928,0,0,1,80-863.643a15.927,15.927,0,0,1,1.288-6.379,16.518,16.518,0,0,1,3.5-5.194,16.517,16.517,0,0,1,5.193-3.5A15.93,15.93,0,0,1,96.357-880a15.93,15.93,0,0,1,6.379,1.288,16.517,16.517,0,0,1,5.193,3.5,16.518,16.518,0,0,1,3.5,5.194,15.927,15.927,0,0,1,1.288,6.379,15.928,15.928,0,0,1-1.288,6.379,16.517,16.517,0,0,1-3.5,5.193,16.517,16.517,0,0,1-5.193,3.5A15.93,15.93,0,0,1,96.357-847.285Zm-1.636-3.353v-3.19a3.15,3.15,0,0,1-2.31-.961,3.15,3.15,0,0,1-.961-2.311v-1.636L83.6-866.587q-.123.736-.225,1.472a10.691,10.691,0,0,0-.1,1.472,12.77,12.77,0,0,0,3.251,8.669A12.59,12.59,0,0,0,94.722-850.638Zm11.287-4.171a13.738,13.738,0,0,0,1.472-1.942,12.379,12.379,0,0,0,1.084-2.167,13.533,13.533,0,0,0,.654-2.31,12.92,12.92,0,0,0,.225-2.413,12.831,12.831,0,0,0-2.229-7.32,12.6,12.6,0,0,0-5.95-4.785v.654a3.15,3.15,0,0,1-.961,2.31,3.15,3.15,0,0,1-2.31.961H94.722v3.271a1.583,1.583,0,0,1-.47,1.166,1.583,1.583,0,0,1-1.165.47H89.814v3.271h9.814a1.583,1.583,0,0,1,1.165.47,1.583,1.583,0,0,1,.47,1.165v4.907H102.9a3.158,3.158,0,0,1,1.922.634A3.234,3.234,0,0,1,106.008-854.81Z"
        transform="translate(-80 880)"
        fill="#6c53a7"
      />
    </svg>
  ),
  Technology: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.077"
      height="26.461"
      viewBox="0 0 33.077 26.461"
    >
      <path
        id="devices_FILL0_wght400_GRAD0_opsz24"
        d="M80-773.539V-778.5h3.308v-18.192a3.185,3.185,0,0,1,.972-2.336A3.185,3.185,0,0,1,86.615-800h24.808v3.308H86.615V-778.5h9.923v4.962Zm21.5,0a1.6,1.6,0,0,1-1.178-.475,1.6,1.6,0,0,1-.475-1.178v-16.538a1.6,1.6,0,0,1,.475-1.178,1.6,1.6,0,0,1,1.178-.475h9.923a1.6,1.6,0,0,1,1.178.475,1.6,1.6,0,0,1,.475,1.178v16.538a1.6,1.6,0,0,1-.475,1.178,1.6,1.6,0,0,1-1.178.475Zm1.654-4.962h6.615v-11.577h-6.615Zm0,0h0Z"
        transform="translate(-80 800)"
        fill="#6c53a7"
      />
    </svg>
  ),
  Languages: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.763"
      height="33.763"
      viewBox="0 0 33.763 33.763"
    >
      <path
        id="language_FILL0_wght400_GRAD0_opsz24"
        d="M96.881-846.237a16.333,16.333,0,0,1-6.542-1.329,17.122,17.122,0,0,1-5.381-3.629,17.123,17.123,0,0,1-3.629-5.381A16.334,16.334,0,0,1,80-863.119a16.288,16.288,0,0,1,1.329-6.563,17.19,17.19,0,0,1,3.629-5.36,17.122,17.122,0,0,1,5.381-3.629A16.334,16.334,0,0,1,96.881-880a16.288,16.288,0,0,1,6.563,1.329,17.19,17.19,0,0,1,5.36,3.629,17.19,17.19,0,0,1,3.629,5.36,16.288,16.288,0,0,1,1.329,6.563,16.334,16.334,0,0,1-1.329,6.542A17.123,17.123,0,0,1,108.8-851.2a17.19,17.19,0,0,1-5.36,3.629A16.287,16.287,0,0,1,96.881-846.237Zm0-3.461a21.428,21.428,0,0,0,1.9-3.165,19.98,19.98,0,0,0,1.308-3.5H93.674a19.98,19.98,0,0,0,1.308,3.5A21.429,21.429,0,0,0,96.881-849.7Zm-4.389-.675a23.4,23.4,0,0,1-1.329-2.891,24.789,24.789,0,0,1-.95-3.1h-4.98a14.008,14.008,0,0,0,3.06,3.672A12.148,12.148,0,0,0,92.492-850.373Zm8.778,0a12.148,12.148,0,0,0,4.2-2.321,14.008,14.008,0,0,0,3.06-3.672h-4.98a24.79,24.79,0,0,1-.95,3.1A23.4,23.4,0,0,1,101.271-850.373ZM83.8-859.742h5.74q-.127-.844-.19-1.667t-.063-1.709q0-.886.063-1.709t.19-1.667H83.8a14.445,14.445,0,0,0-.317,1.667,13.436,13.436,0,0,0-.106,1.709,13.436,13.436,0,0,0,.106,1.709A14.445,14.445,0,0,0,83.8-859.742Zm9.116,0h7.934q.127-.844.19-1.667t.063-1.709q0-.886-.063-1.709t-.19-1.667H92.914q-.127.844-.19,1.667t-.063,1.709q0,.886.063,1.709T92.914-859.742Zm11.311,0h5.74a14.447,14.447,0,0,0,.317-1.667,13.438,13.438,0,0,0,.106-1.709,13.438,13.438,0,0,0-.106-1.709,14.447,14.447,0,0,0-.317-1.667h-5.74q.127.844.19,1.667t.063,1.709q0,.886-.063,1.709T104.225-859.742Zm-.675-10.129h4.98a14.009,14.009,0,0,0-3.06-3.672,12.145,12.145,0,0,0-4.2-2.321,23.393,23.393,0,0,1,1.329,2.891A24.789,24.789,0,0,1,103.549-869.871Zm-9.876,0h6.415a19.98,19.98,0,0,0-1.308-3.5,21.428,21.428,0,0,0-1.9-3.165,21.429,21.429,0,0,0-1.9,3.165A19.98,19.98,0,0,0,93.674-869.871Zm-8.441,0h4.98a24.788,24.788,0,0,1,.95-3.1,23.392,23.392,0,0,1,1.329-2.891,12.145,12.145,0,0,0-4.2,2.321A14.009,14.009,0,0,0,85.233-869.871Z"
        transform="translate(-80 880)"
        fill="#6c53a7"
      />
    </svg>
  ),
};

export const CHECKMARK_ICON = "https://quizzynow.com/images/user/check.svg";

export const SETTINGS_EVERYONE_PROTECTION = 0;
export const SETTINGS_FRIENDS_ONLY_PROTECTION = 1;
export const SETTINGS_MUTUALS_ONLY_PROTECTION = 2;
export const SETTINGS_ONLY_ME_PROTECTION = 3;

export const evaluateTags = function (str, tags) {
  if (str == "") {
    return [];
  }
  str = str.toLowerCase();
  var ptCopy = [];
  TAG_SUGGESTIONS.map((s) => {
    if (
      s.toLowerCase().search(str) != -1 &&
      ptCopy.length < 3 &&
      tags.indexOf(s) == -1
    ) {
      ptCopy.push(s);
    }
  });
  return ptCopy;
};

export const hasAndOr = function (has, Or) {
  return has ? has : Or;
};

export const MAX_IMG_SIZE_MB_PER_MEMBERSHIP = [1, 3, 10, 20];

export const PLAN_DATA = [
  "Quizzy+ Basic Monthly",
  "Quizzy+ Basic Annually",
  "Quizzy+ Standard Monthly",
  "Quizzy+ Standard Annually",
  "Quizzy+ Professional Monthly",
  "Quizzy+ Professional Annually",
];

export const validatePassword = (password) => {
  const MIN_PASSWORD_LENGTH = 8;
  const MAX_PASSWORD_LENGTH = 32;

  if (
    password.length < MIN_PASSWORD_LENGTH ||
    password.length > MAX_PASSWORD_LENGTH
  ) {
    return {
      success: false,
      error: `Password must be at least ${MIN_PASSWORD_LENGTH} characters long, and not more than ${MAX_PASSWORD_LENGTH} characters long.`,
    };
  }

  if (!/[A-Z]/.test(password)) {
    return {
      success: false,
      error: "Password must contain at least one uppercase letter.",
    };
  }

  if (!/[a-z]/.test(password)) {
    return {
      success: false,
      error: "Password must contain at least one lowercase letter.",
    };
  }

  if (!/\d/.test(password)) {
    return {
      success: false,
      error: "Password must contain at least one number.",
    };
  }

  if (!/[^a-zA-Z\d]/.test(password)) {
    return {
      success: false,
      error: "Password must contain at least one special character.",
    };
  }

  return { success: true };
};

export function getGradeColor(grade = null, resultsInfo = null) {
  if (grade == null) {
    grade = resultsInfo?.grade[1];
  }
  if (grade <= 60) {
    return "rgb(216, 60, 60)";
  }
  var t = colorInterpolate(
    "rgb(216, 60, 60)",
    "rgb(88, 232, 146)",
    grade / 100
  );
  return "rgb(" + t["r"] + "," + t["g"] + "," + t["b"] + ")";
}

// extract numeric r, g, b values from `rgb(nn, nn, nn)` string
export function getRgb(color) {
  let [r, g, b] = color
    .replace("rgb(", "")
    .replace(")", "")
    .split(",")
    .map((str) => Number(str));
  return {
    r,
    g,
    b,
  };
}

export function createURLFriendlySetTitle(title) {
  return title.toLowerCase().replace(/\s+/g, "-");
}

export function colorInterpolate(colorA, colorB, intval) {
  const rgbA = getRgb(colorA),
    rgbB = getRgb(colorB);
  const colorVal = (prop) =>
    Math.round(rgbA[prop] * (1 - intval) + rgbB[prop] * intval);
  return {
    r: colorVal("r"),
    g: colorVal("g"),
    b: colorVal("b"),
  };
}

export function getMostMissedColor(missedCount, highestMissedCount) {
  var colorStart, colorEnd;
  var percent = missedCount / highestMissedCount;
  if (percent <= 0.25) {
    colorStart = "rgb(232, 165, 88)"; // #E8A558
    colorEnd = "rgb(232, 132, 88)"; // #E88458
    percent = percent / 0.25; // Scale to 0-1 for this segment
  } else if (percent <= 0.5) {
    colorStart = "rgb(232, 132, 88)"; // #E88458
    colorEnd = "rgb(216, 81, 60)"; // #D8513C
    percent = (percent - 0.25) / 0.25; // Scale to 0-1 for this segment
  } else if (percent <= 0.75) {
    colorStart = "rgb(216, 81, 60)"; // #D8513C
    colorEnd = "rgb(216, 60, 60)"; // #D83C3C
    percent = (percent - 0.5) / 0.25; // Scale to 0-1 for this segment
  } else {
    colorStart = "rgb(216, 60, 60)"; // #D83C3C
    colorEnd = "rgb(255, 0, 0)"; // really red
    percent = (percent - 0.75) / 0.25; // Scale to 0-1 for this segment
  }

  var t = colorInterpolate(colorStart, colorEnd, percent);
  return "rgb(" + t["r"] + "," + t["g"] + "," + t["b"] + ")";
}
